var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"components-page-header border-B"},[_c('div',{staticClass:"logo-icon"}),_c('div',{staticClass:"breadcrumbFlex"},[_c('tagsView')],1),_c('div',{staticClass:"pull-right rightBox"},[(_vm.isLogined)?_c('applicationsSwitchBar'):_vm._e(),_c('userHeaderBar',{staticClass:"marginL30"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }